import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(
  {
    'profile-card-base': {
      border: '1px var(--gray3) solid',
      borderRadius: '5px',
      margin: '16px',
      width: '360px',
      display: 'inline-grid',
      padding: '12px'
    }
  },
  { name: 'bund-' }
)

export const ProfileCardBase = (props) => {
  const classes = useStyles()
  const { children, className, style, ...rest } = props
  return (
    <div
      style={style}
      className={clsx(classes['profile-card-base'], className)}
      {...rest}>
      {children}
    </div>
  )
}

ProfileCardBase.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string
}

ProfileCardBase.displayName = 'pcb'

export default ProfileCardBase
